export default {
  title: 'Ważne uwagi',
  buttons: {
    add_note: 'Dodaj notatkę',
  },
};
